import React, {Fragment, useState, useEffect, useContext} from 'react';
import './VerificationCode.less';
import {Button} from "elements/button/Button";
import {CodePicker} from "compositions/code-picker/CodePicker";
import times from "lodash/times";
import {PinLength, PinTypes} from "new-constants/common.constants";
import {DrawerPopup} from "dialog-layout/drawer-popup/DrawerPopup.tsx";
import {Error} from "elements/error/Error";
import {ConsentText} from "elements/consent-text/ConsentText";
import {Consent} from "compositions/consent/Consent";
import {Link} from 'elements/link/Link'
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";

export const VERIFICATION_CODE_POPUP = 'VERIFICATION_CODE_POPUP';

const ResendTimeout = 15000;

export const VerificationCode = ({isTermsNotAccepted, chainName, termsUrl, phone, error, isRequestInProgress = false, onResendClick, onCancelClick, onDoneClick, onOverlayClick}) => {
	const [code, setCode] = useState(times(PinLength[PinTypes.PHONE_VERIFICATION], () => ''));
	const [termsConsent, setTermsConsent] = useState(false);
	const [marketingConsent, setMarketingConsent] = useState(false);
	const [isResendAvailable, setIsResendAvailable] = useState(false);

	useEffect(() => {
		const resendTimeout = setTimeout(() => {
			setIsResendAvailable(true);
		}, ResendTimeout);

		return () => {
			clearTimeout(resendTimeout);
		}
	}, [isResendAvailable]);

	const translations = useContext(TranslationsContext);

	return <DrawerPopup
		title={getSafeTranslation('VerificationCodePopup.title', translations)}
		description={getSafeTranslation('VerificationCodePopup.description', translations).replace('{phoneNumber}', phone)}
		leftControl={<Button isText onClick={onCancelClick}>{
			getSafeTranslation('VerificationCodePopup.cancelButtonCaption', translations)
		}</Button>}
		leftSecondaryControl={<Button
			isText
			onClick={() => {
				onResendClick();
				setIsResendAvailable(false);
			}}
			isDisabled={!isResendAvailable}
		>
			{getSafeTranslation('VerificationCodePopup.resendButtonCaption', translations)}
		</Button>}
		rightControl={<Button
			isAutoWidth
			onClick={() => onDoneClick(code.join(''), termsConsent, marketingConsent)}
			isDisabled={
				(isTermsNotAccepted && !termsConsent) ||
				code.join('').length < PinLength[PinTypes.PHONE_VERIFICATION] ||
				isRequestInProgress
			}
		>
			{getSafeTranslation('VerificationCodePopup.doneButtonCaption', translations)}
		</Button>}
		onOverlayClick={onOverlayClick}
	>
		<div className="verification-code">
			<div className="verification-code__code">
				<CodePicker enteredValue={code}
										onChange={enteredCode => {
											console.log(enteredCode);
											setCode(enteredCode);
										}}/>
			</div>
			{
				isTermsNotAccepted && (
					<div className="verification-code__terms-consent" onClick={() => setTermsConsent(!termsConsent)}>
						<Consent
							isChecked={termsConsent}
							caption={
								<Fragment>
									<ConsentText
										text={getSafeTranslation('VerificationCodePopup.termsConsentCheckboxCaption', translations)}/>
									<Link url={termsUrl}>
										{getSafeTranslation('VerificationCodePopup.termsLinkCaption', translations)}
									</Link>
								</Fragment>

							}
						/>
					</div>)
			}
			{
				isTermsNotAccepted && (
					<div className="verification-code__marketing-consent" onClick={() => setMarketingConsent(!marketingConsent)}>
						<Consent
							isChecked={marketingConsent}
							caption={<ConsentText
								text={getSafeTranslation('VerificationCodePopup.marketingConsentCheckboxCaption', translations).replace('{chainName}', chainName)}/>}
						/>
					</div>)
			}
			{
				error && (
					<div className="verification-code__error">
						<Error text={error}/>
					</div>
				)
			}
		</div>
	</DrawerPopup>
}
